import $api from '../../http'

export const userQuery = async () => {
    try {
        const res = await $api.api.usersControllerGetMe()
		console.log("[userQuery] API response:", res.data.data);
		console.log("[userQuery] User subscription:", res.data.data?.subscription);
        return res.data.data
    } catch (error) {
        console.error("[userQuery] Error fetching user:", error)
		return undefined
    }
}

export const createAnonymousPaymentQuery = async (planId: string) => {
	try {
		const res = await $api.api.paymentsAnonymousControllerCreate({
			planId: planId,
			paymentMethodId: "card",
			frontendUrl: window.location.origin,
		})
		return res.data
	} catch (error) {
		console.log(error)
	}
}

export const userDeleteQuery = async () => {
    try {
        const res = await $api.api.usersControllerDeleteMe()
        return res.data
    } catch (error) {
        console.log(error)
    }
}

export const cancelSubscriptionQuery = async () => {
    try {
        const res = await $api.api.subscriptionsControllerCancelCurrentSubscription()
        return res.data
    } catch (error) {
        console.log(error)
    }
}

type UpdateUserType = {
    firstName?: string
    lastName?: string
    file?: File
}

export const updateUserQuery = async (props: UpdateUserType) => {
    try {
        const res = await $api.api.usersControllerUpdateMe(
            {
                firstName: props.firstName,
                lastName: props.lastName,
                ...(props.file && { file: props.file }),
            },
        )
        return res.data
    } catch (error) {
        console.log(error)
    }
}

type UserLangProps = {
    languageCode: string
    currencyCode: 'SEK' | 'USD'
}

export const updateUserLangQuery = async (props: UserLangProps) => {
    try {
        const res = await $api.api.usersControllerUpdateMe(
            {
                languageCode: props.languageCode,
                currencyCode: props.currencyCode,
            },
        )
        return res.data
    } catch (error) {
        console.log(error)
    }
}
  export const checkProfessionQuery = async (): Promise<{
    hasProfession: boolean;
    profession?: string | null;
  }> => {
    try {
      // await $api.api.professionControllerCheckProfession();
      return { hasProfession: true }; // Заглушка
    } catch (error) {
      console.error('Failed to check profession:', error);
      return { hasProfession: false };
    }
  };
  
  // Запрос для обновления профессии
  export const updateProfessionQuery = async (profession: string) => {
    try {
      // const res = await $api.api.professionControllerUpdateProfession({ profession });
      // return res.data;
      return Promise.resolve(); // Заглушка
    } catch (error) {
      console.error('Failed to update profession:', error);
      throw error;
    }
  };
